/** Начнет предзагружать следующую порцию данных за 100px сверху */
export const ROOT_MARGIN = '100px 0px 0px 0px';
